import { useEffect, useState } from "react";
import api from "@/lib/api";

let _cache = null;

export function useAssessments() {
  const [assessments, setAssessments] = useState(_cache || []);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    if (_cache) return;
    api.get("/assessments").then(({ data }) => {
      _cache = data.assessments;
      setAssessments(data.assessments);
    }).finally(() => setLoading(false));
  }, []);

  return { assessments, loading };
}
